import { CustomSelect, SelectOption } from '@consigli/facade';
import { useGetPackagesByTypeQuery, useProjectId, useServiceName } from '@consigli/hooks';
import { FieldValues, useController, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { convertServiceNameToId } from '@/features/package-list/package-list';

export const PackagesDropdown = () => {
  const { t } = useTranslation();
  const projectId = useProjectId();
  const serviceName = useServiceName();
  const { data: packages = [] } = useGetPackagesByTypeQuery({
    projectId,
    type: convertServiceNameToId(serviceName),
  });

  const { control } = useFormContext<FieldValues>();
  const { field: packageField, fieldState: packageFieldState } = useController({
    name: 'package',
    control,
    rules: {
      validate: (value) => !!value || `${t('createproject.invalid-project-package-empty')}*`,
    },
  });

  const packageOptions = packages.map((pack) => ({
    label: pack.name,
    value: pack.id,
  }));

  const selectedOption = packageField.value
    ? packageOptions.find((option) => option.value === packageField.value)
    : null;

  return (
    <span className="mb-8 mt-4">
      <CustomSelect
        onChange={(selectedOptions: SelectOption[]) => {
          packageField.onChange(selectedOptions.length > 0 ? selectedOptions[0].value : null);
        }}
        options={packageOptions}
        placeholder={t('package-creation.select-package')}
        value={selectedOption ? [selectedOption] : []}
        noOptionsMessage={t('custom-select.no-options')}
      />
      {packageFieldState.invalid && (
        <div className="text-red-700 text-sm">{packageFieldState.error?.message as string}</div>
      )}
    </span>
  );
};
